import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@allswipes/ui/tokens.css';
import './admin.css';

import { App } from './App';
import { SessionProvider } from './session';
import { ToastProvider } from './toast';

const root = document.getElementById('root');
if (!root) throw new Error('не найден #root');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
